<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <app-col-span v-bind="$attrs">
    <ValidationProvider
      v-slot="v"
      ref="provider"
      :mode="mode"
      :name="name"
      :rules="getRules"
      :vid="vid"
    >
      <slot name="top" />
      <v-file-input
        :clearable="getClearable"
        :counter="counter"
        :counter-value="a => a ? a.length : 0"
        :disabled="disabled"
        :error="getErrorMessages.length>0"
        :error-count="getErrorCount"
        :error-messages="[...getErrorMessages,...v.errors]"
        :label="getLabel"
        :placeholder="getPlaceholder"
        :readonly="readonly"
        :show-size="showSize"
        :value="value"
        style="overflow: hidden"
        v-bind="$attrs"
        v-on="{...$listeners,on:input,change}"
      />
      <slot />
      <slot name="bottom" />
    </ValidationProvider>
  </app-col-span>
</template>

<script>
import { InputsMixin } from '@mixins'

export default {
  name: 'FileInput',
  mixins: [InputsMixin],
  props: {
    showSize: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {},
  methods: {
    input (v) {
      this.$emit('input', v)
    },
    change (v) {
      this.input(v)
      this.$emit('change', v)
    }
  }
}
</script>

<style scoped>

</style>
